export const SIDEBAR_OPEN_SIZE = '18rem';
export const SIDEBAR_CLOSED_SIZE = '6rem';
